import React from 'react';
import { string, func, bool } from 'prop-types';
import clsx from 'clsx';
import HomeIcon from 'assets/images/icons/home.svg';
import MapIcon from 'assets/images/icons/map.svg';
import ShareIcon from 'assets/images/icons/share.svg';
import HelpIcon from 'assets/images/icons/help.svg';
import styles from './MenuButton.module.scss';

const icons = {
  home: <HomeIcon />,
  map: <MapIcon />,
  share: <ShareIcon />,
  help: <HelpIcon />,
};

const MenuButton = ({
  icon,
  label,
  alignLeft,
  alignRight,
  alignBottomLeft,
  alignBottomRight,
  onClick,
  radiusBoth,
  locJP,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={clsx(styles.button, {
      [styles.alignLeft]: alignLeft,
      [styles.alignRight]: alignRight,
      [styles.alignBottomLeft]: alignBottomLeft,
      [styles.alignBottomRight]: alignBottomRight,
      [styles.radiusBoth]: radiusBoth,
      [styles.locJp]: locJP,
    })}
  >
    {icons[icon]}
    {label && <span className={styles.label}>{label}</span>}
  </button>
);

MenuButton.propTypes = {
  icon: string,
  label: string,
  alignLeft: bool,
  alignRight: bool,
  alignBottomLeft: bool,
  alignBottomRight: bool,
  radiusBoth: bool,
  onClick: func.isRequired,
  locJP: bool,
};

MenuButton.defaultProps = {
  icon: null,
  label: null,
  alignRight: false,
  alignLeft: false,
  alignBottomLeft: false,
  alignBottomRight: false,
  radiusBoth: false,
  locJP: false,
};

export default MenuButton;
